import {
  Component,
  ContentChild,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  host: { '[class]': 'classes' },
})
export class ListItemComponent {
  @Input() disabled = false;
  @Input() selected = false;
  @Input() lines: 1 | 2 | 3 = 1;
  @Input() interactive = true;

  @Output() clicked = new EventEmitter<MouseEvent>();

  @ContentChild('leading', { read: TemplateRef })
  leadingTemplate!: TemplateRef<any>;

  @ContentChild('subtitle', { read: TemplateRef })
  subtitleTemplate!: TemplateRef<any>;

  @ContentChild('meta', { read: TemplateRef })
  metaTemplate!: TemplateRef<any>;

  @ContentChild('trailing', { read: TemplateRef })
  trailingTemplate!: TemplateRef<any>;

  get classes(): string {
    const classList: string[] = ['list-item'];
    if (this.disabled) classList.push('disabled');
    if (this.selected) classList.push('selected');
    if (this.lines === 2) classList.push('lines-2');
    if (this.lines === 3) classList.push('lines-3');
    if (!this.interactive) classList.push('non-interactive');
    return classList.join(' ');
  }

  get tabIndex(): number {
    if (!this.interactive) return -1;
    return this.disabled ? -1 : 0;
  }

  get ariaSelected(): string | null {
    return this.selected ? 'true' : null;
  }

  handleClick(event: MouseEvent): void {
    if (!this.disabled && this.interactive) {
      this.clicked.emit(event);
    }
  }

  handleKeydown(event: KeyboardEvent): void {
    if (
      (event.key === 'Enter' || event.key === ' ') &&
      !this.disabled &&
      this.interactive
    ) {
      event.preventDefault();
      this.clicked.emit(event as any);
    }
  }
}
